import type { AvatarProps as MuiAvatarProps } from "@mui/material";
import { Avatar as MuiAvatar } from "@mui/material";
import { forwardRef } from "react";

function getInitials(name: string | undefined): string {
  if (!name) {
    return "";
  }

  const initials = name
    .trim()
    .split(/\s+/)
    .map((val) => val.at(0))
    .filter(Boolean);

  const first = initials.at(0) ?? "";
  const last = initials.length > 1 ? initials.at(-1) : "";
  return `${first}${last}`.toUpperCase();
}

export interface AvatarProps extends Omit<MuiAvatarProps, "children"> {
  name: string;
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(function Avatar(
  { name, ...props },
  ref,
) {
  return (
    <MuiAvatar ref={ref} {...props}>
      {getInitials(name)}
    </MuiAvatar>
  );
});
